module.exports = __webpack_public_path__ + "img/logo.9088b681.png";